import React, { CSSProperties, useMemo } from "react";
import KC_Heading4 from "../typography/KC-Heading/KC_Heading4";
import KC_Heading2 from "../typography/KC-Heading/KC_Heading2";

interface Props {
  title?: string;
  text?: string | number;
  variationText?: string;
  className?: string;
  style?: CSSProperties;
  isHorizontal?: boolean;
}

export default function KC_DashboardCardSmall(props: Props) {
  const className = useMemo(() => {
    return `d-flex flex-row flex-sm-column justify-content-between justify-content-sm-center kc-card-dashboard kc-card-dashboard-small ${props.className || ""}`;
  }, [props.className, props.isHorizontal]);

  return (
    <div className={className} style={props.style}>
      <KC_Heading4
        text={props.title}
        style={{
          wordBreak: "break-word"
        }}
      />
      {!!props.text && <KC_Heading2 text={props.text} primary={true} />}
    </div>
  );
}
